import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';
import ShowDetails from './show-details';
import AstrologyTeeup from './teeups/astrology.js';
import _ from 'underscore';

class Component extends BaseComponent {
    shouldComponentUpdate() {
        return false;
    }

    render({ product }) {
        if (product) {
            return (
                <product-teeup>
                    <img
                        className='product-logo'
                        alt='astrology forecast'
                        src={`https://gfx.tarot.com/images/products/${product.description.slug}/icon.svg`}
                    />
                    {this.renderMessage()}
                    <h1 className='has-text-center'>{product.description.long_name}</h1>
                    <ShowDetails
                        summary={product.description.subheader}
                        details={product.description.long_description}
                    />
                    <AstrologyTeeup />
                </product-teeup>
            );
        }

        return (<product-teeup />);
    }

    renderMessage = () => {
        if (this.props.message) {
            return (<h2 className='has-text-center'>{this.props.message}</h2>);
        } else if (this.props.product.description.message) {
            return (
                <h2 className='fancy-title has-text-boulder has-text-center'>
                    {this.props.product.description.message}
                </h2>
            );
        }

        return null;
    }
}

const mapStateToProps = (state) => ({
    product: state.product,
});

export default connect(mapStateToProps)(Component);
